import axios from 'axios';
import { ModelsDatabaseManager } from '../model/modelsDatabaseManager';
import { Key } from '../model/types';

export class ModelsService {
  constructor(private readonly manager = new ModelsDatabaseManager()) {}

  async get(url: string): Promise<ArrayBuffer> {
    const key = await ModelsService.key(url);

    try {
      const cached = await this.manager.get(key);
      return cached;
    } catch (reason) {
      // Silently fail...
    }

    await this.manager.clean(key);
    const buffer = await ModelsService.fetch(url);
    await this.manager.save(key, buffer);

    return buffer;
  }

  private static async fetch(url: string): Promise<ArrayBuffer> {
    const res = await axios({ url, method: 'GET', responseType: 'arraybuffer' });
    return res.data;
  }

  private static async key(url: string): Promise<Key> {
    const { headers } = await axios({ url, method: 'GET', headers: { Range: 'bytes=0-0' } });
    const { pathname } = new URL(url);
    const decoded = decodeURIComponent(pathname).replaceAll(' ', '_');
    return `instructions:model:${decoded}:etag:${headers.etag ? JSON.parse(headers.etag) : 'none'}`;
  }
}
